import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { images as fallbackImages } from '../../data/images';
import { normalizeImageList } from '../../utils/imageUrl';
export function Gallery({
  images,
  alt
}: {
  images: string[];
  alt: string;
}) {
  const [index, setIndex] = useState(0);
  const normalized = normalizeImageList(images);
  const list = normalized.length ? normalized : [fallbackImages.hero];
  const current = list[Math.min(index, list.length - 1)];
  const onError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    const img = e.currentTarget;
    if (img.src !== fallbackImages.hero) img.src = fallbackImages.hero;
  };
  return <div data-id="element-1079" data-mp="22pymqna1tpmb">
      <div className="relative aspect-[4/3] overflow-hidden rounded-2xl border border-line bg-panel sm:aspect-[16/10]" data-id="element-1080" data-mp="22qrxdzc4oz9q">
        <AnimatePresence initial={false} mode="wait" data-id="element-1081" data-mp="159t8oqxfk5yv">
          <motion.img key={current} src={current} alt={`${alt} — foto ${index + 1} de ${list.length}`} referrerPolicy="no-referrer" onError={onError} className="h-full w-full object-cover" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} transition={{
          duration: 0.18,
          ease: 'easeOut'
        }} data-id="element-1082" data-mp="1a9xosfufeyok" />
        </AnimatePresence>
        <span className="absolute bottom-3 right-3 rounded-md bg-ink/80 px-2 py-1 text-xs text-mist" data-id="element-1083" data-mp="2kyhh2q04jn9h">
          {index + 1} / {list.length}
        </span>
      </div>
      {list.length > 1 && <div className="mt-3 grid grid-cols-4 gap-2 sm:grid-cols-6" data-id="element-1084" data-mp="2az9x3jyvwude">
          {list.map((src, i) => <button key={`${src}-${i}`} onClick={() => setIndex(i)} aria-label={`Ver foto ${i + 1}`} aria-current={i === index} className={`aspect-[4/3] overflow-hidden rounded-lg border-2 transition-colors duration-150 ${i === index ? 'border-neon' : 'border-transparent opacity-70 hover:opacity-100'}`} data-id="element-1085" data-mp="26zhwbtfqfsil" data-mpi={i}>
              <img src={src} alt="" referrerPolicy="no-referrer" onError={onError} className="h-full w-full object-cover" loading="lazy" data-id="element-1086" data-mp="jbu112maazlw" />
            </button>)}
        </div>}
    </div>;
}